@if (isLoading()) {
  <div class="flex items-center justify-center py-6 gap-2 text-xs text-muted-foreground">
    <span class="w-3 h-3 rounded-full border border-primary border-t-transparent animate-spin"></span>
    Vorlagen werden geladen…
  </div>
} @else if (templates().length === 0) {
  <div class="flex flex-col items-center justify-center py-6 gap-2 text-center">
    <ng-icon name="lucideLayoutTemplate" class="w-6 h-6 text-muted-foreground/40" />
    <p class="text-xs text-muted-foreground">
      Keine Vorlagen vorhanden.<br />Erstellen Sie zunächst eine Vorlage im Katalog.
    </p>
  </div>
} @else {
  <div class="space-y-1.5 max-h-52 overflow-y-auto pr-0.5">
    @for (tmpl of templates(); track tmpl.id) {
      <button
        type="button"
        class="w-full flex items-center gap-3 rounded-md border p-3 text-left transition-colors"
        [class]="selectedTemplateId() === tmpl.id ? 'border-primary bg-primary/5' : 'border-border hover:bg-muted/40'"
        [disabled]="state() === 'applying'"
        (click)="select(tmpl.id)"
      >
        <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border bg-muted/50 text-muted-foreground">
          @if (selectedTemplateId() === tmpl.id && state() === 'applying') {
            <span class="w-4 h-4 rounded-full border-2 border-primary border-t-transparent animate-spin"></span>
          } @else {
            <ng-icon name="lucideLayoutTemplate" class="w-4 h-4" />
          }
        </div>
        <div class="flex-1 min-w-0">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="text-sm font-normal">{{ tmpl.name }}</span>
            @if (tmpl.type) {
              <span hlmBadge variant="secondary" class="text-xs shrink-0">{{ getTypeLabel(tmpl.type) }}</span>
            }
            @if (selectedTemplateId() === tmpl.id && state() === 'applied') {
              <span class="inline-flex items-center gap-1 rounded-full border border-primary/30 bg-primary/10 px-2 py-0.5 text-xs font-normal text-primary">
                <ng-icon name="lucideCheck" class="w-2.5 h-2.5" />
                Angewendet
              </span>
            }
          </div>
          <p class="text-xs text-muted-foreground truncate mt-0.5">
            {{ tmpl.description || (tmpl.calculationPeriod + ' Jahre') }}
          </p>
        </div>
      </button>
    }
  </div>

  @if (error()) {
    <p class="text-xs text-destructive mt-2">{{ error() }}</p>
  }
}
